import type { IAdditionalSelectors } from '@makemydeal/dr-activities-tradein';
import { Selectors } from '@makemydeal/dr-activities-tradein';
import type { ITradeIn } from '@makemydeal/dr-platform-types';
import _ from 'lodash';

export class TradeInActivitySelectors extends Selectors {
    constructor(appName: string, additionalSelectors: IAdditionalSelectors) {
        /* istanbul ignore next */
        super(appName, additionalSelectors);
    }

    getTradeIn = (state: any): ITradeIn | any => {
        return this.getTradeInComponent(state) as any;
    };

    getTradeAmountOwed = (state: any) => {
        const amountOwed = this.getTradeInAmountOwed(state);
        return Math.round(amountOwed);
    };

    getNetTrade = (state: any) => {
        const netTrade = this.getTradeInEquity(state);
        return Math.round(netTrade);
    };

    getTradeInSource = (state: any) => {
        const tradeInComponent = this.getTradeInComponent(state);
        return tradeInComponent.source || tradeInComponent.tivSource || null;
    };

    getTradeInEngine = (state: any): string | undefined => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.engine ?? undefined;
    };

    getTradeInTransmission = (state: any): string | undefined => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.transmission ?? undefined;
    };

    getTradeInDriveLine = (state: any): string | undefined => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.driveLine ?? undefined;
    };

    getTradeInBodyStyle = (state: any): string | undefined => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.bodyStyle ?? undefined;
    };

    getTradeInTaxReduction = (state: any) => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.tradeInTaxReduction;
    };

    getTotalTradeInTaxReduction = (state: any) => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.totalTradeInTaxReduction;
    };

    getGoodThroughDate = (state: any) => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.goodThroughDate;
    };

    getLienHolder = (state: any) => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.lienHolder || null;
    };

    getLienHolderAddress = (state: any) => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.lienHolderAddress || null;
    };

    getLienHolderAccountNumber = (state: any) => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.lienHolderAccountNumber || null;
    };

    getLienHolderPhoneNumber = (state: any): string | undefined => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.lienHolderPhoneNumber ?? undefined;
    };

    getPerDiemInterest = (state: any) => {
        const tradeIn = this.getTradeIn(state);
        return tradeIn.perDiemInterest;
    };

    getMileage = (state: any) => {
        const tradeInComponent = this.getTradeInComponent(state);
        return _.toNumber(this.getTradeInVehicleMileage(tradeInComponent));
    };

    getMakeId = (state: any) => {
        const tradeInComponent = this.getTradeInComponent(state);
        return _.toString(this.getTradeInVehicleMakeId(tradeInComponent)) || '';
    };

    getModelId = (state: any) => {
        const tradeInComponent = this.getTradeInComponent(state);
        return _.toString(this.getTradeInVehicleModelId(tradeInComponent)) || '';
    };

    getYear = (state: any) => {
        const tradeInComponent = this.getTradeInComponent(state);
        return _.toNumber(this.getTradeInVehicleYear(tradeInComponent)) || null;
    };

    getZip = (state: any) => {
        const tradeInComponent = this.getTradeInComponent(state);
        return _.toString(this.getTradeInZip(tradeInComponent)) || '';
    };
}
